import * as iFrameResize from '../../../../node_modules/iframe-resizer/js/iframeResizer';

class Iframe {
  constructor(params) {
    this.element = params.element;
    this.width = this.element.dataset.width;
    this.height = this.element.dataset.height;
    this.hasIframeResizer = !!this.element.dataset.hasIframeResizer;
    this.iframeResizerBodyPadding =
      this.element.dataset.iframeResizerBodyPadding;
    this.iFrameResizeInstance = undefined;
  }

  init() {
    if (this.hasIframeResizer) {
      this.initIframeResizer();
      return;
    }

    this.setRatio();
  }

  destroy() {
    this.removeRatio();
  }

  setRatio() {
    if (this.width && this.height) {
      this.element.style.aspectRatio = `${this.width}/${this.height}`;
    }
  }

  removeRatio() {
    this.element.style.aspectRatio = '';
  }

  initIframeResizer() {
    this.iFrameResizeInstance = iFrameResize.default(
      {
        checkOrigin: true,
        bodyPadding:
          typeof this.iframeResizerBodyPadding === 'string'
            ? this.iframeResizerBodyPadding
            : null,
      },
      this.element
    );
  }
}

const iframes = document.querySelectorAll('.iframe__iframe');
const iframeInstances = [];

iframes.forEach(element => {
  const iframeInstance = new Iframe({ element });
  iframeInstance.init();
  iframeInstances.push(iframeInstance);
});
